export const translations = {
  en: {
    paragraph_text:
      ' You should go to an InstaCare IF you feel short of breath, including when walking. You should call 911 right away IF you are experiencing potential life-threatening symptom which include:',
    paragraph_text2: 'STOP and read the items below carefully:',
    bullet_point1: 'Moderate to severe shortness of breath and difficulty breathing',
    bullet_point2: 'Crushing chest pain',
    bullet_point3: 'Loss of consciousness',
    bullet_point4: 'Slurred speech',
    bullet_point5: 'Gasping for air',
    bullet_point6: 'Coughing up lots of blood',
    bullet_point7_1:
      'This screening is ONLY for individuals that can produce saliva (drool). If you need a COVID-19 test other than saliva please contact your primary care provider or if you are in Utah visit',
    bullet_point7_2: 'In Idaho you may proceed with the survey.',
    bullet_point8:
      'If your child is less than three months and having symptoms, call your pediatrician or visit an Intermountain InstaCare/KidsCare for evaluation.',
    bullet_point9:
      ' If you are having a baby or a procedure at an Intermountain facility you do NOT need to create an order here. Your doctor will order you a COVID-19 test.',
    instructions: 'Please select your reason(s) for requesting a COVID-19 test:',
    checkbox1: 'I have been experiencing COVID-19 symptoms',
    checkbox2: 'I was in close contact with a confirmed COVID-19 case',
    checkbox3: 'School related',
    checkbox4: 'Work related',
    checkbox5: 'Travel related',
    checkbox6: 'I live in a high density residence (e.g. college dorm, homeless shelter)'
  },
  es: {
    paragraph_text:
      'Debe ir al InstaCare si siente falta de aire, incluso al caminar. Debe llamar al 911 inmediatamente si experimenta síntomas que puedan amenazar su vida incluyendo:',
    paragraph_text2: 'DETÉNGASE y lea cuidadosamente los artículos a continuación:',
    bullet_point1: 'Dificultad para respirar o falta de aire moderada o grave',
    bullet_point2: 'Dolor de pecho aplastante',
    bullet_point3: 'Pérdida de conocimiento',
    bullet_point4: 'Balbuceo',
    bullet_point5: 'Jadeo',
    bullet_point6: 'Toser mucha sangre',
    bullet_point7_1:
      'Esta prueba es SOLAMENTE para individuos que pueden producir saliva (baba).  Si necesita una prueba de COVID-19 que no sea con saliva contacte a su médico de cabecera o si está en Utah visite',
    bullet_point7_2: 'Si está en Idaho puede continuar con el cuestionario.',
    bullet_point8:
      'Si su hijo es menor de tres meses de edad y tiene síntomas, llame a su pediatra o a Intermountain InstaCare/KidsCare para que lo evalúen.',
    bullet_point9:
      'Si va a dar a luz o tener un procedimiento en una instalación de Intermountain NO necesita crear una orden aquí.  Su doctor le dará una orden para una prueba de COVID-19.',
    instructions: 'Seleccione las razones por las que solicita una prueba de COVID-19:',
    checkbox1: 'He estado experimentando síntomas de COVID-19',
    checkbox2: 'Estuve en contacto cercano con un caso de COVID-19 confirmado',
    checkbox3: 'Relacionado con la escuela',
    checkbox4: 'Relacionado con el trabajo',
    checkbox5: 'Planeo ir de viaje',
    checkbox6: 'Vivo en una residencia de alta densidad (ej. dormitorio universitario, asilo)'
  }
};
